export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/f22f8de0-3219-4bfb-a79a-cca655c4b9d1/images/ac5d899d6d9ff276864773e867259a7e9fceac9934a718dce0f56e2dc1db6383.jpeg";

export const UNLOCK_FEE = 26.99;
export const APPLICATION_FEE = 77.99;

export const CONTACT_PHONE = "079 755 1251";
export const CONTACT_WHATSAPP_LINK = "https://wa.me/27797551251";
export const CONTACT_EMAIL = "yourvarsityapplication@gmail.com";

export function percentageToLevel(pct) {
  const p = Number(pct);
  if (isNaN(p)) return 0;
  if (p >= 80) return 7;
  if (p >= 70) return 6;
  if (p >= 60) return 5;
  if (p >= 50) return 4;
  if (p >= 40) return 3;
  if (p >= 30) return 2;
  return 1;
}

export function computeAps(marks) {
  const graded = marks
    .filter((m) => m.subject && m.percentage !== "" && m.percentage != null)
    .map((m) => ({ ...m, level: percentageToLevel(m.percentage) }));
  const counting = graded
    .filter((g) => g.subject !== "Life Orientation")
    .sort((a, b) => b.level - a.level)
    .slice(0, 6);
  const aps = counting.reduce((s, g) => s + g.level, 0);
  return { aps, graded };
}
